<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="addItem()" round >ADD SPEED PROFILE</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD SPEED PROFILE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex  xs12 sm6 md6> 
                  <v-text-field v-model="editedItem.downloadMbps"
                   label="*Download Mbps" required type="number"></v-text-field>
                </v-flex>

                <v-flex  xs12 sm6 md6> 
                  <v-text-field v-model="editedItem.uploadMbps"
                   label="*Upload Mbps" required type="number"></v-text-field> 
                   </v-flex>

                <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                label="*Contention Ratio" :items="contentionRatios" 
                v-model="editedItem.contentionRatio" > </v-autocomplete>

                </v-flex>
               <v-flex xs12 sm6 md6>
                  <v-btn v-if="chooseColourBtn" @click="changeBtn()" flat color="primary" class="white--text">Select Color</v-btn>
                 <v-layout justify-center align-center>
                    <chromepicker v-if="!chooseColourBtn" v-model="colour" /></v-layout>
                </v-flex>
               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="saveNew">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT SPEED PROFILE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                 <v-flex  xs12 sm6 md6> 
                  <v-text-field v-model="editedItem.downloadMbps"
                   label="*Download Mbps" required type="number"></v-text-field>
                </v-flex>

                <v-flex  xs12 sm6 md6> 
                  <v-text-field v-model="editedItem.uploadMbps"
                   label="*Upload Mbps" required type="number"></v-text-field> 
                   </v-flex>

                <v-flex xs12 md6>
                 <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                label="*Contention Ratio" :items="contentionRatios" 
                v-model="editedItem.contentionRatio" ></v-autocomplete>
                </v-flex>
                 <v-flex xs12 sm6 md6>
                 <v-layout v-if="editedItem.colour" justify-center align-center>
                    <chromepicker v-model="editedItem.colour" />
                    </v-layout>
           
                  <v-btn v-else @click="changeBtn()" flat color="primary" class="white--text">Select Color</v-btn>
            
                 </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="save">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="speedProfiles"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >

        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.downloadMbps}}</td>
          <td class="text-xs-center">{{props.item.uploadMbps}}</td>
          <td class="text-xs-center">{{props.item.contentionRatio}}</td>
          <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>
          
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
     
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import { Chrome } from 'vue-color'
export default {
  components: {
      'chromepicker': Chrome
  },
  data() {
    return {
    chooseColourBtn:true,
    colour: '#000000',
    contentionRatios: ["1:10", "1:4", "1:1"],
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Download Mbps",
        align: "center",
        value: "downloadMbps"
      },
      {
        text: "Upload Mbps",
        align: "center",
        value: "uploadMbps"
      },
      {
        text: "Contention Ratio",
        align: "center",
        value: "contentionRatio"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }    
    ],
    speedProfiles: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        downloadMbps: null,
        uploadMbps: null,
        contentionRatio: "",
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
        name: "",
        downloadMbps: null,
        uploadMbps: null,
        contentionRatio: "",
        
        isActive: true,
        isDeleted: false
    },
        displayIntegerError: false,
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },  
  watch: {
    dialog(val) {
      val || this.close();
    },
    search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    // '$route.query':{
    //   immediate: true,
    //   async handler(value){
    //     this.speedProfiles= await this.searchSpeedProfiles(value)
    //   }
    // },
    //  '$route.query.search':{
    //   immediate: true,
    //   handler(value){
    //     this.search=value
    //   },
    // }, 
  },
  async created() {
        this.initialize();
  },
  methods: {
    changeBtn(){
            if(this.chooseColourBtn===false){
                    this.chooseColourBtn=true
            }else{
                this.chooseColourBtn=false
            }
        },
     searchSpeedProfiles(search){
        this.isloading=true
      if(search.search!==""){      
        Api()
        .get('/speedProfiles',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.speedProfiles=response.data
           this.isloading=false
        })} 
      },
    fetchSpeedProfiles() {
      this.isloading=true
      Api()
        .get("/speedProfiles/active")
        .then(response => {
          this.speedProfiles = response.data;
             this.isloading=false
        });
      
    },     
    
    initialize() {
      this.fetchSpeedProfiles();
    },
    addItem(){
      // if(this.authCreate(this.$store.state.currentRoute)){
        this.chooseColourBtn = true
        this.newDialog=true
      // }
    },
    editItem(item) {
      // if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.speedProfiles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      // }
    },
      deleteItem(id) {
        // if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/speedProfiles/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
          this.fetchSpeedProfiles()
        })
        // }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      console.log(this.editedItem.colour)
        let proceed=true
        if(this.editedItem.downloadMbps == null || this.editedItem.downloadMbps == ''){
          proceed =false
          confirm('Please fill in the download Mbps (number only).')
        }
        if(this.editedItem.uploadMbps == null || this.editedItem.uploadMbps == ''){
             proceed =false
          confirm('Please fill in the upload Mbps (number only).')
        }
        if(this.editedItem.contentionRatio == ""){
          proceed =false
          confirm('Please select the contention ratio.')
        }
        if(this.editedItem.colour == ""){
          proceed =false
          confirm('Please select a colour.')
        }
         if (proceed ==true ) {
        Api().put("/speedProfiles/" + this.editedItem.id, {
          name:  `${this.editedItem.downloadMbps}D-${this.editedItem.uploadMbps}U-${this.editedItem.contentionRatio}`,
          downloadMbps: this.editedItem.downloadMbps,
          uploadMbps: this.editedItem.uploadMbps,
          contentionRatio: this.editedItem.contentionRatio,
          colour: this.editedItem.colour.hex,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive
        }).then(response=>{
         this.fetchSpeedProfiles();
        })
        this.close();
        Object.assign(this.speedProfiles[this.editedIndex], this.editedItem);
      }
    },
      saveNew() {
         let proceed=true
        if(this.editedItem.downloadMbps ==  null){
          proceed =false
          confirm('Please fill in the download Mbps (number only).')
        }
        if(this.editedItem.uploadMbps ==  null){
             proceed =false
          confirm('Please fill in the upload Mbps (number only).')
        }
        if(this.editedItem.contentionRatio == ""){
          proceed =false
          confirm('Please select the contention ratio.')
        }
         if(this.colour == "#000000"){
          proceed =false
          confirm('Please select a colour.')
        }
         if (proceed ==true ) {
        Api().post("/speedProfiles", {
          name:  `${this.editedItem.downloadMbps}D-${this.editedItem.uploadMbps}U-${this.editedItem.contentionRatio}`,
          downloadMbps: this.editedItem.downloadMbps,
          uploadMbps: this.editedItem.uploadMbps,
          contentionRatio: this.editedItem.contentionRatio,
          colour: this.colour.hex,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive    
        }).then(response=>{
         this.fetchSpeedProfiles();
        })
        this.close();
    }
  }
  }
};
</script>